import { TeamHelmet } from './TeamHelmet'
import { TEAM_BOX_FIELDS, UNOWNED_STAT } from '../lib/teamBoxScore'
import type { TeamStatSummary } from '../types'
import './TeamBoxScore.css'

/**
 * One team's post-game summary: helmet, score, and the twelve totals the
 * box score advertises.
 *
 * @remarks
 * Figures come from {@link TEAM_BOX_FIELDS}. Adding a row there is enough for
 * this card and the upload preview to pick it up; the grid is three columns
 * so a multiple of three keeps the last row full. Pass {@link seasonNumber}
 * so extras the v5 ROM started recording in season 34 stay blank on older
 * games instead of reading as zeros.
 */
export function TeamBoxScore({
  team,
  venue,
  eyebrow,
  seasonNumber,
}: {
  team: TeamStatSummary
  venue?: 'home' | 'away'
  eyebrow?: string
  seasonNumber?: number
}) {
  return (
    <div className="team-box">
      <header className="team-box__head">
        <TeamHelmet abbreviation={team.abbreviation} size="lg" />
        <div className="team-box__identity">
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <div className="team-box__name-row">
            <span className="team-box__abbr">{team.abbreviation}</span>
            {venue && (
              <span className={`badge team-box__venue team-box__venue--${venue}`}>
                {venue === 'home' ? 'Home' : 'Away'}
              </span>
            )}
          </div>
        </div>
        <span className="team-box__score numeric">{team.score}</span>
      </header>
      <dl className="team-box__grid">
        {TEAM_BOX_FIELDS.map(field => {
          const recorded =
            field.sinceSeason == null || (seasonNumber ?? 0) >= field.sinceSeason
          return (
            <div key={field.key}>
              <dt>{field.label}</dt>
              <dd className={recorded ? 'numeric' : 'numeric team-box__empty'}>
                {recorded ? field.value(team) : UNOWNED_STAT}
              </dd>
            </div>
          )
        })}
      </dl>
    </div>
  )
}
